module.exports = __webpack_public_path__ + "d91d3db6226170c3782352da2d7d7e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-5000-purple.jpg
// module id = 835
// module chunks = 0